<div class="sidebar">
    <div class="logopanel">
        <h1>
            <a [routerLink]="['/']">IQM Ispezioni</a>
        </h1>
    </div>
    <div class="sidebar-inner">
        <div class="sidebar-top">
            <div class="userlogged clearfix">
                <i class="icon icons-faces-users-01"></i>
                <div class="user-details">
                    <h4>{{ user.username }}</h4>
                    <div class="dropdown user-login">
                        <div class="btn btn-xs btn-rounded" style="cursor: auto;">
                            <i class="online"></i><span>Disponibile</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ul class="nav nav-sidebar" style="margin-top: 40px;">
            <li *ngIf="user.fk_id_role <= 1" [routerLinkActive]="['nav-active', 'active']" class="nav-parent" style="width: 100%;">
                <a href=""><i class="icon-check"></i><span>Checklist </span><span class="fa arrow"></span></a>
                <ul class="children collapse">
                    <li [routerLinkActive]="['active']">
                        <a [routerLink]="['/checklist']"> Generale</a>
                    </li>
                    <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a [routerLink]="['/checklist/create']"> Crea Nuova Checklist</a>
                    </li>
                </ul>
            </li>
            <li *ngIf="user.fk_id_role <= 1" [routerLinkActive]="['nav-active', 'active']" class="nav-parent">
                <a href=""><i class="icon-handbag"></i><span>Convenzioni </span><span class="fa arrow"></span></a>
                <ul class="children collapse">
                    <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a [routerLink]="['/contract']"> Generale</a>
                    </li>
                    <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a [routerLink]="['/contract/create']"> Crea Nuova Convenzione</a>
                    </li>
                </ul>
            </li>
            <li *ngIf="user.fk_id_role <= 1" [routerLinkActive]="['nav-active', 'active']" [routerLinkActiveOptions]="{exact:true}" class="nav-parent" style="width: 100%;">
                <a href=""><i class="fa fa-upload"></i><span>Importa Ispezione </span><span class="fa arrow"></span></a>
                <ul class="children collapse">
                    <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a [routerLink]="['/inspection/import']"> Upload Ispezioni</a>
                    </li>
                    <li *ngIf="user.fk_id_role <= 1" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a [routerLink]="['/inspection/create']"> Crea Nuova Ispezione</a>
                    </li>
                </ul>
            </li>
            <li *ngIf="user.fk_id_role <= 1" [routerLinkActive]="['nav-active', 'active']" [routerLinkActiveOptions]="{exact:false}" class="nav-parent" style="width: 100%;">
                <a [routerLink]="['/inspection-general']"><i class="fa fa-suitcase"></i><span>Gestione Ispezioni</span></a>
            </li>
            <li *ngIf="user.fk_id_role <= 2" [routerLinkActive]="['nav-active', 'active']" [routerLinkActiveOptions]="{exact:false}" class="nav-parent" style="width: 100%;">
                <a [routerLink]="['/schedule']"><i class="fa fa-calendar"></i><span>Programmazione</span></a>
            </li>
            <li *ngIf="user.fk_id_role <= 4" [routerLinkActive]="['nav-active', 'active']" [routerLinkActiveOptions]="{exact:true}" class="nav-parent" style="width: 100%;">
                <a [routerLink]="['/inspection']"><i class="glyphicon glyphicon-map-marker"></i><span>Ispezione</span></a>
            </li>
            <li *ngIf="user.fk_id_role <= 1" [routerLinkActive]="['nav-active', 'active']" [routerLinkActiveOptions]="{exact:true}" class="nav-parent" style="width: 100%;">
                <a [routerLink]="['/contract-report']"><i class="fa fa-book"></i><span>Relazione Finale</span></a>
            </li>
            <li *ngIf="user.fk_id_role <= 1" [routerLinkActive]="['nav-active', 'active']" class="nav-parent">
                <a href=""><i class="icon-user"></i><span>Utenti </span><span class="fa arrow"></span></a>
                <ul class="children collapse">
                    <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a [routerLink]="['/user']"> Generale</a>
                    </li>
                    <li [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
                        <a [routerLink]="['/user/create']"> Crea Nuovo Utente</a>
                    </li>
                </ul>
            </li>
        </ul>
        <div class="sidebar-footer clearfix">
            <a class="pull-left footer-settings" routerLink="/user/settings" data-rel="tooltip" data-placement="top" data-original-title="Impostazioni">
                <i class="icon-settings"></i></a>
            <a class="pull-left toggle_fullscreen" href="#" data-rel="tooltip" data-placement="top" data-original-title="Fullscreen">
                <i class="icon-size-fullscreen"></i></a>
            <a class="pull-left" href="user-lockscreen.html" data-rel="tooltip" data-placement="top" data-original-title="Lockscreen">
                <i class="icon-lock"></i></a>
            <a (click)="signOut($event)" class="pull-left btn-effect" style="cursor: pointer;" data-modal="modal-1" data-rel="tooltip" data-placement="top" data-original-title="Logout">
                <i class="icon-power"></i></a>
        </div>
    </div>
</div>
